export const FETCH_ALL = "FETCH_ALL";
export const UPDATE = "UPDATE";
export const CREATE = "CREATE";
export const DELETE = "DELETE";
export const LIKE = "LIKE";

export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
